// extracted by mini-css-extract-plugin
module.exports = {"gooey":"Preloader_gooey__3Bmz4","dot":"Preloader_dot__3OIle","dots":"Preloader_dots__2OQxa"};